import { render } from "./CardCoinPreference.vue?vue&type=template&id=7222c452"
import script from "./CardCoinPreference.vue?vue&type=script&lang=js"
export * from "./CardCoinPreference.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__